import {
  EDIT_MACHINE,
  LIST_MACHINE,
  STORE_MACHINE,
  LIST_GAME,
  EDIT_GAME,
  STORE_GAME,
  EDIT_ASSIGN_MACHINE,
  LIST_ASSIGN_MACHINE,
  STORE_ASSIGN_MACHINE,
  UPDATE_READING,
  STORE_READING,
  LIST_READING,
  STORE_ALL_READING,
  LIST_MATCH_TICKETS,
  STORE_ALL_MATCH_TICKETS,
  CLOCK_IN,
  CLOCK_OUT,
  STORE_CLOCK,
  LOAD_CLOCK_RECORD,
  LIST_EMPLOYEE_SESSION,
  STORE_ALL_EMPLOYEE_SESSION,
  UPDATE_EMPLOYEE_STATUS,
  STORE_UPDATED_EMPLOYEE_SESSION,
  MANUAL_CLOCK_IN,
  DELETE_EMPLOYEE_SESSION,
  FORCE_CLOCK_OUT,
  GET_POINT_WATCHING,
  STORE_POINT_WATCHING,
  GET_POINT_WATCHING_BY_DATE,
  STORE_POINT_WATCHING_BY_DATE,
  GET_POINT_WATCHING_EMPLOYEE_DAYS,
  STORE_POINT_WATCHING_EMPLOYEE_DAYS,
  GET_POINT_WATCHING_DAY_ENTRIES,
  STORE_POINT_WATCHING_DAY_ENTRIES,
  GET_POINT_WATCHING_ALERTS,
  STORE_POINT_WATCHING_ALERTS,
  CLEAR_POINT_WATCHING_ALERT,
  MATCH_POINT_PDF_PREVIEW,
  MATCH_POINT_RESET_PDF_PREVIEW_DATA,
  MATCH_POINT_STORE_PDF_PREVIEW_READY,
  MASTER_READING_PDF_PREVIEW,
  MASTER_READING_RESET_PDF_PREVIEW_DATA,
  MASTER_READING_STORE_PDF_PREVIEW_READY,
  LIST_SESSION_IDS,
  STORE_ALL_SESSION_IDS,
  CLEAR_READING,
  ADD_MACHINE_PICTURE,
  STORE_MACHINE_PICTURE,
  LIST_MACHINE_PICTURE,
  START_LOADING,
  STOP_LOADING,
  DELETE_MACHINE_PICTURE,
  STORE_CATEGORY,
  LIST_CATEGORY,
  EDIT_CATEGORY,
  AVAILABLE_EMPLOYEE_SESSIONS,
  STORE_AVAILABLE_EMPLOYEE_SESSIONS,
  START_SESSION,
  END_SESSION,
  STORE_STARTED_SESSION,
  LOAD_STARTED_SESSION,
  STORE_RESPONSE_MESSAGE,
  RESET_ASSIGN_MACHINE,
  STORE_NOTES,
  ADD_NOTE,
  DELETE_NOTE,
  LIST_NOTES,
  STORE_REPORT,
  LIST_REPORT,
  UPDATE_REPORT_FIELD,
  CLEAR_WEEKLY_REPORT,
  STORE_AVAILABLE_COMPANIES,
  SET_AVAILABLE_COMPANIES_STATUS,
  LIST_AVAILABLE_COMPANIES,
  CREATE_COMPANY,
  UPDATE_COMPANY,
  STORE_COMPANIES,
  LIST_COMPANIES,
  ACTIVATE_LICENSE,
  STORE_LICENSE,
  GENERATE_LICENSE,
  GET_LICENSE,
  RENEW_LICENSE,
  REVOKE_LICENSE,
  LIST_ACTIVE_LICENSES,
  STORE_ACTIVE_LICENSES,
  UPDATE_LICENSE_AMOUNT,
  LIST_LICENSE_PAYMENTS,
  STORE_LICENSE_PAYMENTS,
  UPDATE_LICENSE_PAYMENT,
  RECORD_NEXT_CYCLE_PAYMENT,
  MARK_CYCLE_PAID,
  GET_COMPANY_MEMBERSHIPS,
  STORE_COMPANY_MEMBERSHIPS,
  ACTUAL_PROJECTIONS,
  YEARLY_PROJECTIONS,
  STORE_ACTUAL_PROJECTIONS,
  STORE_YEARLY_PROJECTIONS,
  GET_PREV_IN_OUT,
  UPDATE_MANAGER_BANK,
  EDIT_BANK_BOARD_ENTRY,
  DELETE_BANK_BOARD_ENTRY,
  STORE_MANAGER_SETTING,
  SAVE_MANAGER_SETTING,
  GET_MANAGER_SETTING,
  SAVE_MANAGER_SUMMARY,
  LIST_SHORT_ANALYSIS,
  STORE_SHORT_ANALYSIS,
  LIST_MASTER_ADMINS_LOCATION,
  STORE_MASTER_ADMINS_LOCATION,
  OPEN_SESSION_READING,
  GET_LAST_SESSION_READING,
  CANCEL_SESSION,
  LIST_DELETED_READING_SESSIONS,
  RESTORE_READING_SESSION,
  DELETE_FOREVER_READING_SESSION,
  GRANT_MAINTENANCE_PERMIT,
  REVOKE_MAINTENANCE_PERMIT,
  LOAD_MAINTENANCE_PERMIT,
  STORE_MAINTENANCE_PERMIT,
  STORE_MAINTENANCE_PERMIT_HISTORY,
} from '../../constants/settings';
import { PREVIEW_POINT_WATCHING_IMAGE } from '../../constants/customer';
import {
  DELETE_BONUS,
  DELETE_MANAGE_BONUS,
  LIST_CLAIM_BONUS,
  LIST_MANAGE_BONUS,
  LIST_RULES,
  PREVIEW_BONUS_IMAGE,
  SAVE_BONUS,
  SAVE_MANAGE_BONUS,
  TOGGLE_MANAGE_BONUS,
  SAVE_RULES,
  STORE_CLAIM_BONUS,
  STORE_MANAGE_BONUS,
  STORE_RULES,
  STORE_UPDATED_BONUS_IMAGE_WITH_PREVIEW,
  UPLOAD_BONUS_PHOTO,
} from '../../constants/ticketOut';

//COMPANY
export const listCompanies = () => ({
  type: LIST_COMPANIES,
});

export const listMasterAdminsPerLocation = (data) => ({
  type: LIST_MASTER_ADMINS_LOCATION,
  data,
});

export const createCompany = (company, refresh) => ({
  type: CREATE_COMPANY,
  company,
  refresh,
});

export const updateCompany = (updatedCompany, refresh) => ({
  type: UPDATE_COMPANY,
  updatedCompany,
  refresh,
});

export const storeCompanies = (companies) => ({
  type: STORE_COMPANIES,
  companies,
});

export const storeMasterAdmins = (data) => ({
  type: STORE_MASTER_ADMINS_LOCATION,
  data,
});

export const listAvailableCompanies = () => ({
  type: LIST_AVAILABLE_COMPANIES,
});

export const storeAvailableCompanies = (availableCompanies) => ({
  type: STORE_AVAILABLE_COMPANIES,
  availableCompanies,
});

// 'loading' | 'failed'. A successful fetch resets it to 'idle' through
// STORE_AVAILABLE_COMPANIES, so only these two are ever dispatched.
export const setAvailableCompaniesStatus = (status) => ({
  type: SET_AVAILABLE_COMPANIES_STATUS,
  status,
});

export const getLicenseKey = (data) => ({
  type: GET_LICENSE,
  data,
});

export const generateLicenseKey = (data) => ({
  type: GENERATE_LICENSE,
  data,
});

export const revokeLicenseKey = (data) => ({
  type: REVOKE_LICENSE,
  data,
});

export const handleRenewLicenseKey = (data, callback) => ({
  type: RENEW_LICENSE,
  data,
  callback,
});

export const updateLicenseAmount = (data, callback) => ({
  type: UPDATE_LICENSE_AMOUNT,
  data,
  callback,
});

export const listLicensePayments = (data) => ({
  type: LIST_LICENSE_PAYMENTS,
  data,
});

export const updateLicensePayment = (data, callback) => ({
  type: UPDATE_LICENSE_PAYMENT,
  data,
  callback,
});

export const recordNextCyclePayment = (data, callback) => ({
  type: RECORD_NEXT_CYCLE_PAYMENT,
  data,
  callback,
});

export const markCyclePaid = (data, callback) => ({
  type: MARK_CYCLE_PAID,
  data,
  callback,
});

export const storeLicensePayments = (payments, totalCount = 0) => ({
  type: STORE_LICENSE_PAYMENTS,
  payments,
  totalCount,
});

export const getCompanyMemberships = (year) => ({
  type: GET_COMPANY_MEMBERSHIPS,
  year,
});

export const storeCompanyMemberships = (memberships) => ({
  type: STORE_COMPANY_MEMBERSHIPS,
  memberships,
});

export const getActualProjections = (data) => ({
  type: ACTUAL_PROJECTIONS,
  data,
});

export const getYearlyProjections = (data) => ({
  type: YEARLY_PROJECTIONS,
  data,
});

export const storeActualProjections = (data) => ({
  type: STORE_ACTUAL_PROJECTIONS,
  data,
});

export const storeYearlyProjections = (data) => ({
  type: STORE_YEARLY_PROJECTIONS,
  data,
});

export const storeLicenseKey = (licenseKey) => ({
  type: STORE_LICENSE,
  licenseKey,
});

export const activateLicenseKey = (data, callback) => ({
  type: ACTIVATE_LICENSE,
  data,
  callback,
});

export const listActiveLicense = () => ({
  type: LIST_ACTIVE_LICENSES,
});

export const storeActiveLicense = (licenses) => ({
  type: STORE_ACTIVE_LICENSES,
  licenses,
});

// MACHINE
export const editMachine = (
  machines,
  locationId,
  deletedMachineIds,
  callback
) => ({
  type: EDIT_MACHINE,
  machines,
  locationId,
  deletedMachineIds,
  callback,
});

export const listMachine = (locationId) => ({
  type: LIST_MACHINE,
  locationId,
});

export const listReading = (sessionId, locationId) => ({
  type: LIST_READING,
  sessionId,
  locationId,
});

export const clearReading = () => ({
  type: CLEAR_READING,
});

export const clearWeeklyReport = () => ({
  type: CLEAR_WEEKLY_REPORT,
});

export const listSessionIds = (fromDate, toDate, locationId) => ({
  type: LIST_SESSION_IDS,
  fromDate,
  toDate,
  locationId,
});

export const updateReportField = (
  sessionId,
  field,
  newValue,
  locationId,
  callback,
  // Optional. Loan In sends the manager's reason for overriding the
  // derived total; the server writes it in the same transaction as the
  // amount. undefined means "not supplied" and leaves any existing note
  // alone — only an explicit '' clears one.
  note
) => ({
  type: UPDATE_REPORT_FIELD,
  sessionId,
  field,
  newValue,
  locationId,
  callback,
  note,
});

export const updateManagerBank = (data, callback) => ({
  type: UPDATE_MANAGER_BANK,
  data,
  callback,
});

export const editBankBoardEntry = (data, callback) => ({
  type: EDIT_BANK_BOARD_ENTRY,
  data,
  callback,
});

export const deleteBankBoardEntry = (data, callback) => ({
  type: DELETE_BANK_BOARD_ENTRY,
  data,
  callback,
});

export const storeAllSessionIds = (data) => ({
  type: STORE_ALL_SESSION_IDS,
  data,
});

export const storeMachine = (machine) => ({
  type: STORE_MACHINE,
  machine,
});

//GAME
export const editGame = (games, locationId, callback) => ({
  type: EDIT_GAME,
  games,
  locationId,
  callback,
});

export const listGame = (locationId) => ({
  type: LIST_GAME,
  locationId,
});

export const storeGame = (game) => ({
  type: STORE_GAME,
  game,
});

//ASSIGN MACHINE TO GAME
export const editAssignMachine = (
  assignTemplates,
  locationId,
  deletedAssignMachineIds,
  callback
) => ({
  type: EDIT_ASSIGN_MACHINE,
  assignTemplates,
  locationId,
  deletedAssignMachineIds,
  callback,
});

export const resetMachine = (assignMachineId, callback) => ({
  type: RESET_ASSIGN_MACHINE,
  assignMachineId,
  callback,
});

export const updateReading = (data, locationId, callback) => ({
  type: UPDATE_READING,
  data,
  locationId,
  callback,
});

export const openLastSessionReading = (locationId, callback) => ({
  type: OPEN_SESSION_READING,
  locationId,
  callback,
});

export const getSessionReading = (locationId, callback) => ({
  type: GET_LAST_SESSION_READING,
  locationId,
  callback,
});

export const storeStartedSession = (data) => ({
  type: STORE_STARTED_SESSION,
  data,
});

export const loadStartedSession = (locationId) => ({
  type: LOAD_STARTED_SESSION,
  locationId,
});

export const startSession = (data, callback) => ({
  type: START_SESSION,
  data,
  callback,
});

export const getPrevInAndOut = (data, callback) => ({
  type: GET_PREV_IN_OUT,
  data,
  callback,
});

export const endSession = (data, callback) => ({
  type: END_SESSION,
  data,
  callback,
});

export const cancelSession = (data, callback) => ({
  type: CANCEL_SESSION,
  data,
  callback,
});

export const listDeletedReadingSessions = (data, callback) => ({
  type: LIST_DELETED_READING_SESSIONS,
  data,
  callback,
});

export const restoreReadingSession = (data, callback) => ({
  type: RESTORE_READING_SESSION,
  data,
  callback,
});

export const deleteForeverReadingSession = (data, callback) => ({
  type: DELETE_FOREVER_READING_SESSION,
  data,
  callback,
});

export const availableEmployeeSessions = (data) => ({
  type: AVAILABLE_EMPLOYEE_SESSIONS,
  data,
});

export const storeAvailableEmployeeSessions = (data) => ({
  type: STORE_AVAILABLE_EMPLOYEE_SESSIONS,
  data,
});

export const listAssignMachine = (locationId) => ({
  type: LIST_ASSIGN_MACHINE,
  locationId,
});

export const resetReading = () => ({
  type: 'RESET_READING',
});

export const storeAssignMachine = (assignTemplates) => ({
  type: STORE_ASSIGN_MACHINE,
  assignTemplates,
});

export const storeReading = (reading) => ({
  type: STORE_READING,
  reading,
});

export const storeAllReadings = (readings) => ({
  type: STORE_ALL_READING,
  readings,
});

export const listMatchTickets = (sessionId, locationId) => ({
  type: LIST_MATCH_TICKETS,
  sessionId,
  locationId,
});

export const storeAllMatchTickets = (
  differenceList,
  employeeTickets,
  session
) => ({
  type: STORE_ALL_MATCH_TICKETS,
  differenceList,
  employeeTickets,
  session,
});

//Clock

export const clockIn = (data, callback) => ({
  type: CLOCK_IN,
  data,
  callback,
});

export const clockOut = (data, callback) => ({
  type: CLOCK_OUT,
  data,
  callback,
});

export const loadClockRecords = (data, callback) => ({
  type: LOAD_CLOCK_RECORD,
  data,
  callback,
});

export const storeClock = (clockRecord) => ({
  type: STORE_CLOCK,
  clockRecord,
});

//Employee
export const listEmployeeSession = (data) => ({
  type: LIST_EMPLOYEE_SESSION,
  data,
});

export const deleteEmployeeSession = (data, callback) => ({
  type: DELETE_EMPLOYEE_SESSION,
  data,
  callback,
});

export const manualClockIn = (data, callback) => ({
  type: MANUAL_CLOCK_IN,
  data,
  callback,
});

export const forceClockOut = (data, callback) => ({
  type: FORCE_CLOCK_OUT,
  data,
  callback,
});

export const storeAllEmployeeSession = (employeeSession) => ({
  type: STORE_ALL_EMPLOYEE_SESSION,
  employeeSession,
});

export const storeUpdatedEmployeeSession = (clockRecord) => ({
  type: STORE_UPDATED_EMPLOYEE_SESSION,
  clockRecord,
});

export const updateEmployeeStatus = (data, callback, fromDate, toDate) => ({
  type: UPDATE_EMPLOYEE_STATUS,
  data,
  callback,
  fromDate,
  toDate,
});

//PointsWatching

export const getPointWatching = (data) => ({
  type: GET_POINT_WATCHING,
  data,
});

export const storePointWatching = (pointsWatching) => ({
  type: STORE_POINT_WATCHING,
  pointsWatching,
});

// Points Watching (spec v1.0) — By session
export const getPointWatchingByDate = (data) => ({
  type: GET_POINT_WATCHING_BY_DATE,
  data,
});

export const storePointWatchingByDate = (byDate) => ({
  type: STORE_POINT_WATCHING_BY_DATE,
  byDate,
});

// Points Watching (spec v1.0) — By employee: days worked
export const getPointWatchingEmployeeDays = (data) => ({
  type: GET_POINT_WATCHING_EMPLOYEE_DAYS,
  data,
});

export const storePointWatchingEmployeeDays = (employeeDays) => ({
  type: STORE_POINT_WATCHING_EMPLOYEE_DAYS,
  employeeDays,
});

// Points Watching (spec v1.0) — By employee: one day's entries
export const getPointWatchingDayEntries = (data) => ({
  type: GET_POINT_WATCHING_DAY_ENTRIES,
  data,
});

export const storePointWatchingDayEntries = (dayEntries) => ({
  type: STORE_POINT_WATCHING_DAY_ENTRIES,
  dayEntries,
});

// Points Watching (spec v1.0) — alerts (no clear subject)
export const getPointWatchingAlerts = (data) => ({
  type: GET_POINT_WATCHING_ALERTS,
  data,
});

export const storePointWatchingAlerts = (alerts) => ({
  type: STORE_POINT_WATCHING_ALERTS,
  alerts,
});

// Points Watching — dismiss a single no-clear-subject alert (audited)
export const clearPointWatchingAlert = (data, callback) => ({
  type: CLEAR_POINT_WATCHING_ALERT,
  data,
  callback,
});

//match report
export const getMatchPointPDFPreview = (pdfPreview, setPdfError) => ({
  type: MATCH_POINT_PDF_PREVIEW,
  pdfPreview,
  setPdfError,
});

export const storeMatchPointPDFPreviewReady = (
  storeMatchPointPDFPreviewReady
) => ({
  type: MATCH_POINT_STORE_PDF_PREVIEW_READY,
  storeMatchPointPDFPreviewReady,
});

export const resetMatchPointPdfPreviewData = () => ({
  type: MATCH_POINT_RESET_PDF_PREVIEW_DATA,
});

export const previewPointsWatchingImage = (previewRequest, callback) => ({
  type: PREVIEW_POINT_WATCHING_IMAGE,
  previewRequest,
  callback,
});

// master Reading Report
export const getMasterReadingPDFPreview = (pdfPreview, setPdfError) => ({
  type: MASTER_READING_PDF_PREVIEW,
  pdfPreview,
  setPdfError,
});

export const storeMasterReadingPDFPreviewReady = (
  storeMasterReadingPDFPreviewReady
) => ({
  type: MASTER_READING_STORE_PDF_PREVIEW_READY,
  storeMasterReadingPDFPreviewReady,
});

export const resetMasterReadingPdfPreviewData = () => ({
  type: MASTER_READING_RESET_PDF_PREVIEW_DATA,
});

//manage bonus
export const saveManageBonus = (data, callback) => ({
  type: SAVE_MANAGE_BONUS,
  data,
  callback,
});

export const listManageBonus = (data) => ({
  type: LIST_MANAGE_BONUS,
  data,
});

export const storeManageBonus = (bonus) => ({
  type: STORE_MANAGE_BONUS,
  bonus,
});

export const deleteManageBonus = (data) => ({
  type: DELETE_MANAGE_BONUS,
  data,
});

export const toggleManageBonus = (data, callback) => ({
  type: TOGGLE_MANAGE_BONUS,
  data,
  callback,
});

//bonus
export const previewBonusImage = (previewRequest) => ({
  type: PREVIEW_BONUS_IMAGE,
  previewRequest,
});

export const storeUpdatedBonusImageWithPreview = (previewedFile) => ({
  type: STORE_UPDATED_BONUS_IMAGE_WITH_PREVIEW,
  previewedFile,
});

export const storeClaimBonus = (bonus) => ({
  type: STORE_CLAIM_BONUS,
  bonus,
});

export const listClaimBonus = (data) => ({
  type: LIST_CLAIM_BONUS,
  data,
});

export const deleteBonus = (data) => ({
  type: DELETE_BONUS,
  data,
});

export const saveBonus = (data, callback) => ({
  type: SAVE_BONUS,
  data,
  callback,
});

// photo: { bonusId, phone, displayName, blob } — enqueued for the
// background upload saga; callers persist it to the photo outbox first
// (components/bonus/photoOutbox.js) so it survives reloads.
export const uploadBonusPhoto = (photo) => ({
  type: UPLOAD_BONUS_PHOTO,
  photo,
});

// actions/global.js
export const triggerRefresh = (socket) => ({
  type: 'TRIGGER_REFRESH',
  socket,
});

export const setBlacklistAlert = (data) => ({
  type: 'SET_BLACKLIST_ALERT',
  payload: data,
});

//RULES

export const saveRules = (data, callback) => ({
  type: SAVE_RULES,
  data,
  callback,
});

export const listRules = (data) => ({
  type: LIST_RULES,
  data,
});

export const storeRules = (rules) => ({
  type: STORE_RULES,
  rules,
});

//
export const addMachinePicture = (data, callback) => ({
  type: ADD_MACHINE_PICTURE,
  data,
  callback,
});

export const listMachinePicture = (data) => ({
  type: LIST_MACHINE_PICTURE,
  data,
});

export const deleteMachinePicture = (data) => ({
  type: DELETE_MACHINE_PICTURE,
  data,
});

export const storeAllMachinePicture = (allMachinePictures) => ({
  type: STORE_MACHINE_PICTURE,
  allMachinePictures,
});

//loading
export const startLoading = () => ({ type: START_LOADING });
export const stopLoading = () => ({ type: STOP_LOADING });

//Transaction Category
export const editCategory = (locationId, categories, callback) => ({
  type: EDIT_CATEGORY,
  locationId,
  categories,
  callback,
});

export const listCategory = (locationId) => ({
  type: LIST_CATEGORY,
  locationId,
});

export const storeCategory = (category) => ({
  type: STORE_CATEGORY,
  category,
});

export const storeResponseMessage = (responseMessage) => ({
  type: STORE_RESPONSE_MESSAGE,
  responseMessage,
});

//GAME
export const addNote = (data, callback) => ({
  type: ADD_NOTE,
  data,
  callback,
});

export const deleteNote = (data) => ({
  type: DELETE_NOTE,
  data,
});

export const listNotes = (data) => ({
  type: LIST_NOTES,
  data,
});

export const storeNotes = (notes) => ({
  type: STORE_NOTES,
  notes,
});

//week report
export const listReport = (data) => ({
  type: LIST_REPORT,
  data,
});

export const storeReport = (
  weekReport,
  summary,
  employeeSummary,
  managerSummary,
  summaryBreakdown
) => ({
  type: STORE_REPORT,
  weekReport,
  summary,
  employeeSummary,
  managerSummary,
  summaryBreakdown,
});

//short analysis (Equation X)
export const listShortAnalysis = (data) => ({
  type: LIST_SHORT_ANALYSIS,
  data,
});

export const storeShortAnalysis = (shortAnalysis) => ({
  type: STORE_SHORT_ANALYSIS,
  shortAnalysis,
});

//manager summary

export const getManagerSummary = (data, callback) => ({
  type: GET_MANAGER_SETTING,
  data,
  callback,
});

export const saveManagerSetting = (data, callback) => ({
  type: SAVE_MANAGER_SETTING,
  data,
  callback,
});

export const storeManagerSetting = (data) => ({
  type: STORE_MANAGER_SETTING,
  data,
});

export const saveManagerSummary = (data, callback) => ({
  type: SAVE_MANAGER_SUMMARY,
  data,
  callback,
});

//Maintenance Permit
export const grantMaintenancePermit = (data, callback) => ({
  type: GRANT_MAINTENANCE_PERMIT,
  data,
  callback,
});

export const revokeMaintenancePermit = (data, callback) => ({
  type: REVOKE_MAINTENANCE_PERMIT,
  data,
  callback,
});

export const loadMaintenancePermit = (data) => ({
  type: LOAD_MAINTENANCE_PERMIT,
  data,
});

export const storeMaintenancePermit = (permit) => ({
  type: STORE_MAINTENANCE_PERMIT,
  permit,
});

export const storeMaintenancePermitHistory = (history) => ({
  type: STORE_MAINTENANCE_PERMIT_HISTORY,
  history,
});
